import { redirect } from 'react-router-dom';
import { BaseLoader } from '@/utils/rtk/base.loader';
import { clientsApi } from './clientsApi';

export class ClientLoader extends BaseLoader {
	detailLoader = async ({ params, request }) => {
		const client = await this._loader(
			clientsApi.endpoints.getClientProperties,
			request,
			params.clientId,
		);
		const { clientRow, insight, broker } = client ?? {};

		// A numeric id is a HubSpot id from an old link; send it to the doc-id URL.
		if (clientRow?.id && /^\d+$/.test(params.clientId)) {
			const url = new URL(request.url);
			const pathname = url.pathname
				.split('/')
				.map((segment) => (segment === params.clientId ? clientRow.id : segment))
				.join('/');
			return redirect(`${pathname}${url.search}`);
		}

		return { clientRow, insight, broker };
	};
}
